import {
  AUTO_UPDATED_STORAGE_KEY,
  startAppVersionMonitor,
} from '@/lib/appVersionMonitor'

const IDENTITY_INDEX_URL = '/index.html'

export function useAppVersionMonitor() {
  const showUpdateBanner = ref(false)
  const wasAutoUpdated = ref(false)

  onMounted(() => {
    if (!import.meta.env.PROD) {
      return
    }

    if (sessionStorage.getItem(AUTO_UPDATED_STORAGE_KEY)) {
      sessionStorage.removeItem(AUTO_UPDATED_STORAGE_KEY)
      wasAutoUpdated.value = true
    }

    startAppVersionMonitor({
      indexUrl: IDENTITY_INDEX_URL,
      onUpdateAvailable: () => {
        showUpdateBanner.value = true
      },
      onForcedReload: () => {
        sessionStorage.setItem(AUTO_UPDATED_STORAGE_KEY, '1')
      },
    })
  })

  function reloadForUpdate() {
    window.location.reload()
  }

  return {
    showUpdateBanner,
    wasAutoUpdated,
    reloadForUpdate,
  }
}
